import Vue from "vue";
import Router from "vue-router";
import AppHeader from "@/layout/AppHeader";
import AppFooter from "@/layout/AppFooter";
import Components from "@/views/Layout.vue";
import Landing from "@/views/Landing.vue";
import Login from "@/views/Login.vue";
import Register from "@/views/Register.vue";
import Profile from "@/views/Profile.vue";
import Carnaval from "@/views/components/eventos/evento.vue";
Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      redirect: "/",
      component: () => import("@/views/Layout.vue"),
      children: [
        {
          path: "/",
          name: "home",
          component: () => import("@/views/components/eventos/eventos.vue"),
          meta: { title: 'home' }
        },
        {
          path: "/ingressos",
          name: "ingressos",
          component: () => import("@/views/components/ingressos/ingresso.vue"),
        },
        {
          path: "/compras",
          name: "compras",
          component: () => import("@/views/components/ingressos/pix.vue"),
        },
        {
          path: "/produtor",
          name: "produtor",
          component: () => import("@/views/components/produtor/produtor.vue"),
        },
        {
          path: "/relatorioVendas",
          name: "relatorioVendas",
          component: () => import("@/views/components/produtor/relatorioVendas.vue"),
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("@/views/components/usuario/cadastro.vue"),
        },
     
        {
          path: "/eventosMed",
          name: "eventosMed",
          component: () => import("@/views/components/eventos/eventosMed.vue"),
          meta: { title: 'home' }
        },
   
        {
          path: "/landing",
          name: "landing",
          component: () => import("@/views/Landing.vue"),
        },
        {
          path: "/Carnaval",
          name: "Carnaval",
          component: () => import("@/views/components/eventos/eventosCarnaval.vue"),
        },
        {
          path: "/login",
          name: "login",
          components: Login
        },
        {
          path: "/register",
          name: "register",
          components: Register,

        },
        {
          path: "/:nome?/:id?",
          name: "evento",
          component: () => import("@/views/components/eventos/eventoMeu.vue"),
        },
        {
          path: "preview/:nome?/:id?",
          name: "eventoprodutor",
          component: () => import("@/views/components/eventos/eventoProdutor.vue"),
        },
        {
          path: "Carnaval/:nome?/:id?",
          name: "carnavalevento",
          component: () => import("@/views/components/eventos/eventoCarnaval.vue"),
        },
        // {
        //   path: "/profile",
        //   name: "profile",
        //   component: () => import("@/views/Profile.vue"),
        // },
     
      
     
      ]
    }],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
